import { SVGAttributes } from 'react'

const TrashIcon = (props: SVGAttributes<SVGElement>) => (
    <svg fill={props.color || 'white'} viewBox="0 0 18 20" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.5879 2.5C17.7029 2.5 17.8003 2.45931 17.8802 2.37793C17.9601 2.29655 18 2.19727 18 2.08008V0.419921C18 0.302734 17.9601 0.20345 17.8802 0.12207C17.8003 0.0406898 17.7029 0 17.5879 0H0.412141C0.297125 0 0.199681 0.0406898 0.119808 0.12207C0.0399361 0.20345 0 0.302734 0 0.419921V2.08008C0 2.19727 0.0399361 2.29655 0.119808 2.37793C0.199681 2.45931 0.297125 2.5 0.412141 2.5H17.5879ZM14.722 20C14.8243 20 14.9153 19.9642 14.9952 19.8926C15.0751 19.821 15.1214 19.7331 15.1342 19.6289L16.361 4.16992H1.63898L2.86581 19.6289C2.87859 19.7331 2.92492 19.821 3.00479 19.8926C3.08466 19.9642 3.17572 20 3.27796 20H14.722Z"
        />
    </svg>
)

export default TrashIcon
